import { BaseEntity } from "yt-ng-framework";

export class OkrugView extends BaseEntity{
    constructor(){
        super();
    };

    Naziv:string = null;
    Drzava:string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Drzava = input.Drzava;       
        return this;
    }

    Serialize(input: OkrugView){
        return input;
    }

}